<article class="box_default box_white" [ngClass]="{'with-overlay': modalView != VIEW_MODAL_NONE }">
	<!-- modals for user remove -->
	<core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_MODAL_REMOVE_USER_WARNING"
		[type]="'warning-alert'"
		[message]="'Warning'"
		[text]="'You are about to remove a user from its allocated seat. The user will loose access to the system. The data associated will NOT be deleted.'"
		[buttonText]="'I UNDERSTAND'"
		(action)="onUserRemove()"
		[secondButtonText]="'Go Back'"
		(secondButtonAction)="dismiss()">
	</core-layout-modal-feedback>
	<core-layout-modal-feedback class="modal-feedback modal-feedback-success" *ngIf="modalView == VIEW_MODAL_REMOVE_USER_SUCCESS"
		[type]="'success'"
		[message]="'Success'"
		[text]="'The user has been removed from its assigned seat<br/> and won’t be able to log in.'"
		[buttonText]="'Ok'"
		(action)="onActionSuccess($event)">
	</core-layout-modal-feedback>
	<core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_MODAL_REMOVE_USER_ERROR"
    [type]="'fail'"
    [message]="'Error'"
    [text]="'Oops! It looks like this user could not be removed.<br/> Please try again. If the error persists, <br/>please reach out to our support team through the Help Me button.'"
    [buttonText]="'OK'"
    (action)="dismiss($event)">
  </core-layout-modal-feedback>
	<!-- modals for invitation cancel -->
	<core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_MODAL_CANCEL_INVITATION_WARNING"
		[type]="'warning-alert'"
		[message]="'Warning'"
		[text]="'If you cancel the invitation, the user will not be able<br/> to create an account and will not be able to log in.'"
		[buttonText]="'I UNDERSTAND'"
		(action)="onInvitationCancel()"
		[secondButtonText]="'Go Back'"
		(secondButtonAction)="dismiss()">
	</core-layout-modal-feedback>
	<core-layout-modal-feedback class="modal-feedback modal-feedback-success" *ngIf="modalView == VIEW_MODAL_CANCEL_INVITATION_SUCCESS"
		[type]="'success'"
		[message]="'Success'"
		[text]="'The invitation has been canceled,<br/> the user won’t create an account.'"
		[buttonText]="'Ok'"
		(action)="onActionSuccess($event)">
	</core-layout-modal-feedback>
	<core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_MODAL_CANCEL_INVITATION_ERROR"
    [type]="'fail'"
    [message]="'Error'"
    [text]="'Oops! It looks like the invitation could not be canceled.<br/> Please try again. If the error persists, <br/>please reach out to our support team through the Help Me button.'"
    [buttonText]="'OK'"
    (action)="dismiss($event)">
  </core-layout-modal-feedback>
	<div class="list-users">
		<div class="loader" *ngIf="!ready else userslist">
			<div class="dimmed">
				<header>
					<div class="dimmed_flex">
						<div class="dimmed_title"></div><span class="sep">-</span>
						<div class="dimmed_title"></div>
					</div>
				</header>
				<div class="dimmed_flex">
					<div class="dimmed_flex_section">
						<div class="dimmed_avatar"></div>
						<div class="dimmed_info">
							<div class="dimmed_title"></div>
							<div class="dimmed_subtitle"></div>
							<div class="dimmed_subtitle"></div>
						</div>
					</div>
				</div>
				<div class="dimmed_flex">
					<div class="dimmed_flex_section">
						<div class="dimmed_avatar"></div>
						<div class="dimmed_info">
							<div class="dimmed_title"></div>
							<div class="dimmed_subtitle"></div>
							<div class="dimmed_subtitle"></div>
						</div>
					</div>
				</div>
				<div class="dimmed_flex">
					<div class="dimmed_flex_section">
						<div class="dimmed_avatar"></div>
						<div class="dimmed_info">
							<div class="dimmed_title"></div>
							<div class="dimmed_subtitle"></div>
							<div class="dimmed_subtitle"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ng-template #userslist>
			<header>
				<h3>{{ (usersSeats != null && usersSeats.length > 0) ? (usersSeats.length+1) + ' Active Users' : '1 Active User'}} - {{seatsAvailable}} seat{{(seatsAvailable > 1) ? 's':''}} available</h3>
			</header>
			<div *ngIf="usersSeats != null" class="users_list">
				<ul>
					<li *ngIf="ownerSeat != null">
						<settings-users-info-user-seat [seatSetting]="ownerSeat"></settings-users-info-user-seat>
					</li>
					<li *ngIf="loggedUserSeat != null">
						<settings-users-info-user-seat [seatSetting]="loggedUserSeat"></settings-users-info-user-seat>
					</li>
					<!-- seat status marks the difference between current users and invitations -->
					<!-- user list items  -->
					<li *ngFor="let seat of usersSeats | seatsSortByName: 'asc'">
						<settings-users-info-user-seat [seatSetting]="seat" [menu]="menu" (onAction)="onMenuClick($event, seat)"></settings-users-info-user-seat>
					</li>
					<!-- invitation list items -->
					<li class="inactive invitation"  *ngFor="let inv of invitations | seatsSortByName: 'asc'">
						<settings-users-info-user-seat [seatSetting]="inv" [menu]="menuInvitation" (onAction)="onMenuInvitationClick($event, inv)"></settings-users-info-user-seat>
					</li>
				</ul>
			</div>
		</ng-template>	
		<core-helpers-box-alert-try-again *ngIf="seatsHttpStatus.code == 2" [text]="'List hasn’t loaded correctly.'" (tryAgain)="tryAgain()"></core-helpers-box-alert-try-again>	
	</div>
</article>